import { createContext, type ReactNode, useContext, useState } from "react";
import type { DisplayCurrency } from "../lib/types";

interface CurrencyContextValue {
  currency: DisplayCurrency;
  setCurrency: (currency: DisplayCurrency) => void;
  toggleCurrency: () => void;
}

const CurrencyContext = createContext<CurrencyContextValue | null>(null);
const storageKey = "expense-analyzer-display-currency";

function getInitialCurrency(): DisplayCurrency {
  return window.localStorage.getItem(storageKey) === "EUR" ? "EUR" : "USD";
}

export function CurrencyProvider({ children }: { children: ReactNode }) {
  const [currency, setCurrencyState] = useState<DisplayCurrency>(getInitialCurrency);

  function setCurrency(value: DisplayCurrency) {
    window.localStorage.setItem(storageKey, value);
    setCurrencyState(value);
  }

  function toggleCurrency() {
    setCurrency(currency === "USD" ? "EUR" : "USD");
  }

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, toggleCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency(): CurrencyContextValue {
  const context = useContext(CurrencyContext);

  if (!context) {
    throw new Error("useCurrency must be used within CurrencyProvider.");
  }

  return context;
}
